"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssertionError extends Error {
    constructor(message) {
        super(`This is an unexpected error. The likely causes are:
  - passed in an unexpected type to a method call
  - forgot to call Exceptional#get
If you are sure that the error is not on your side, please submit a bug report with the relevant code and the following message: "${message}"`);
    }
}
exports.default = AssertionError;
